module.exports = __webpack_public_path__ + "img/Medal.b576b35e.png";